export const API_URL = window.location.origin
export const PRODUCTS_URL = API_URL + "/public_content/products.json";